module.exports = __webpack_public_path__ + "img/logout_menu.d9b3e754.svg";